/**
 * @module features/devices/utils/macFormatter
 * @description Pure MAC address helpers mirroring the backend normaliser so
 * users get instant, consistent feedback before submitting.
 */
import { MAC_REGEX } from "../types";

/** True when the value is a syntactically valid MAC in a supported notation. */
export function isValidMac(value: string): boolean {
  return MAC_REGEX.test(value.trim());
}

/**
 * Normalise a MAC to uppercase colon notation (XX:XX:XX:XX:XX:XX).
 * Returns the trimmed input unchanged when it is not a valid MAC, so callers
 * can still show the raw value next to a validation error.
 */
export function normalizeMac(value: string): string {
  const trimmed = value.trim();
  if (!isValidMac(trimmed)) return trimmed;
  const digits = trimmed.replace(/[^0-9A-Fa-f]/g, "").toUpperCase();
  return digits.match(/.{2}/g)!.join(":");
}
